var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"satellite-status",class:("_" + _vm.status)},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      content: _vm.label,
      triggers: ['hover', 'click'],
    }),expression:"{\n      content: label,\n      triggers: ['hover', 'click'],\n    }"}],staticClass:"satellite-status__dot"}),(_vm.showText)?_c('span',{staticClass:"satellite-status__text"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }